export const workOrdersReducer = (state = { loading: true, resultWorkOrder: null, workOrders: null, initialBalance: null, workOrder: null, numWorkOrder: null, duplicatedWorkOrder: null, total: 0, workOrdersCalendar: [] }, action) => {
    switch (action.type) {
        case 'WORKORDER_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                workOrders: action.payload.workOrders,
                total: action.payload.total
            }
        case 'WORKORDER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                workOrder: action.payload
            }
        case 'WORKORDER_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                workOrders: [...state.workOrders, action.payload.workOrder],
                resultWorkOrder: action.payload.message
            }
        case 'NUM_WORKORDER_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                numWorkOrder: action.payload
            }
        case 'WORKORDER_EDIT_SUCCESS':
            return {
                ...state,
                loading: false,
                resultWorkOrder: action.payload.message,
                workOrders: state.workOrders.map(workOrder =>
                    workOrder._id === action.payload.workOrder._id
                        ? action.payload.workOrder
                        : workOrder
                )
            }
        case 'WORKORDER_DUPLICATE_SUCCESS':
            return {
                ...state,
                loading: false,
                workOrders: [...state.workOrders, action.payload.workOrder],
                resultWorkOrder: action.payload.message,
                duplicatedWorkOrder: action.payload.workOrder
            }
        case 'WORKORDER_DUPLICATED':
            return {
                ...state,
                loading: false,
                resultWorkOrder: action.payload.message,
                numWorkOrder: action.payload.lastNumWorkOrder
            }
        case 'WORKORDER_REMOVE_RESULT':
            return {
                ...state,
                loading: false,
                resultWorkOrder: action.payload.message,
                workOrders: state.workOrders.filter(workOrders => workOrders._id !== action.payload.workOrder)
            }
        case 'WORKORDER_RESET_RESULT':
            return {
                ...state,
                resultWorkOrder: null
            }
        case 'WORKORDER_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'WORKORDER_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'WORKORDER_GETALL_CALENDAR_SUCCESS':
            return {
                ...state,
                workOrdersCalendar: action.payload
            }
        case 'WORKORDERS_RESET':
            return {
                ...state,
                workOrders: null
            }
        default:
            return state
    }
}

